/* Keep variant-specific signup triggers inside Pipeline's rendered product form. */
(() => {
  let scheduled = false;
  const bound = new WeakSet();
  function sync() {
    scheduled = false;
    document.querySelectorAll('.product-page [data-doop-restock-product]').forEach(slot => {
      const button = slot.querySelector('.doop-restock-trigger');
      if (!button) return;
      const ready = typeof window._RestockRocket?.openModal === 'function';
      const soldOut = slot.dataset.doopRestockAvailable === 'false' && !!slot.dataset.doopRestockId;
      button.hidden = !soldOut || !ready;
      const wrapper = slot.closest('.product__block__buttons');
      wrapper?.classList.toggle('doop-restock-managed', ready);
      if (bound.has(button)) return;
      bound.add(button);
      button.addEventListener('click', () => {
        const status = slot.querySelector('[role="status"]');
        try {
          const app = window._RestockRocket;
          if (typeof app?.openModal !== 'function') throw new Error('App unavailable');
          const product = JSON.parse(slot.dataset.doopRestockProduct);
          app.openModal(product, String(slot.dataset.doopRestockId));
          status.textContent = '';
        } catch (error) {
          status.textContent = 'Restock alerts are temporarily unavailable. Please try again shortly.';
        }
      });
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-doop-restock-id', 'data-doop-restock-available', 'data-doop-restock-product']
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule);
  sync();
  let attempts = 0;
  const timer = setInterval(() => {
    sync();
    if (++attempts >= 120) clearInterval(timer);
  }, 500);
})();
